// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MessageActions_root__AB8As {
  background: #F7F7F7;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
}

.MessageActions_group__Q1JhI {
  display: flex;
  align-items: center;
  justify-content: center;
}
.MessageActions_icon__T5jGt {
  cursor: pointer;
  width: 48px;
  height: 48px;
  border: 0;
  background: transparent;
}

.MessageActions_closeButton__FbEnb {
  display: flex;
  align-items: center;
  justify-content: center;
}
.MessageActions_closeButton__FbEnb > svg {
  transition: 0.3s all;
  transform: rotate(0deg);
}
.MessageActions_closeButton__FbEnb:hover > svg {
  transform: rotate(180deg);
}`, "",{"version":3,"sources":["webpack://./src/components/chats/ui/ChatBottomPanels/MessageActions/MessageActions.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EAEA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAAF;AAOA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,uBAAA;AALF;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AALF;AAOE;EACE,oBAAA;EACA,uBAAA;AALJ;AAQE;EACE,yBAAA;AANJ","sourcesContent":[".root {\n  background: #F7F7F7;\n\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 0;\n}\n\n.group {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  &>:not(:last-child) {\n    //margin-right: 6px;\n  }\n}\n\n.icon {\n  cursor: pointer;\n  width: 48px;\n  height: 48px;\n  border: 0;\n  background: transparent;\n}\n\n.closeButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > svg {\n    transition: 0.3s all;\n    transform: rotate(0deg);\n  }\n\n  &:hover > svg {\n    transform: rotate(180deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `MessageActions_root__AB8As`,
	"group": `MessageActions_group__Q1JhI`,
	"icon": `MessageActions_icon__T5jGt`,
	"closeButton": `MessageActions_closeButton__FbEnb`
};
export default ___CSS_LOADER_EXPORT___;
